<script>
  import Menu from '$lib/../components/Menu.svelte';
  import TrackingScripts from '$lib/../components/seo/TrackingScripts.svelte';
  import Footer from '$lib/../components/Footer.svelte';
  
  import "$lib/css/app.css";

  export let data;
</script>
<main class="prose prose-xl">
	{#if data.globaleInstellingen}
		<Menu algemeen={data.globaleInstellingen} />
    <slot />
    <Footer algemeen={data.globaleInstellingen} />
    {#if data.globaleInstellingen.content.enable_GTM && data.storyVersion === 'published'}
      <TrackingScripts gtm_id={data.globaleInstellingen.content.gtm_id} />
    {/if}
  {/if}
</main>
